const numberFormat = new Intl.NumberFormat("en-US");
const pluralRules = new Intl.PluralRules("en-US");

export const formatCount = (n) => numberFormat.format(n);

// plural(1, "chat", "chats") -> "1 chat"; plural(1284, "chat", "chats") -> "1,284 chats"
export function plural(n, one, other) {
  return `${numberFormat.format(n)} ${pluralRules.select(n) === "one" ? one : other}`;
}

const segmenter = typeof Intl.Segmenter === "function" ? new Intl.Segmenter(undefined, { granularity: "grapheme" }) : null;
const LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;

function graphemes(word) {
  return segmenter ? Array.from(segmenter.segment(word), (s) => s.segment) : Array.from(word);
}

function firstLetter(word) {
  return graphemes(word).find((g) => LETTER_OR_DIGIT.test(g)) || "";
}

// Initials from the first and last word, by grapheme; emoji and symbols are skipped.
export function initials(name) {
  const letters = String(name || "")
    .trim()
    .split(/\s+/)
    .map(firstLetter)
    .filter(Boolean);
  if (letters.length === 0) return "\u2022";
  const picked = letters.length === 1 ? letters[0] : letters[0] + letters[letters.length - 1];
  return picked.toUpperCase();
}

// 65 -> "1:05", 1500 -> "25:00", 3900 -> "1:05:00"
export function formatClock(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = String(s % 60).padStart(2, "0");
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${sec}` : `${m}:${sec}`;
}
